module.exports = __webpack_public_path__ + "static/media/pink_red1.21e4d7dd.jpg";